import React from 'react'
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import './MasterCalendar.css'

const localizer = momentLocalizer(moment);

const MasterCalendar = () => {

  // (year, month is a indexed so april is the 4th which it is the 3rd index, data is the date, time is military time )
    const events = [
        {
          title: 'Start Competive Practice ',
          start: new Date(2023, 4, 16, 17, 30),
          end: new Date(2023, 6, 16, 19, 0),
        },
        {
          title: 'Last Competive Practice ',
          start: new Date(2023, 9, 27, 17, 30),
          end: new Date(2023, 9, 27, 19, 0),
        },
        {
          title: 'Rec. Coaches Clinic',
          start: new Date(2023, 7, 27, 16, 0),
          end: new Date(2023, 7, 27, 17, 0),
        },
        {
          title: 'Youth Referee Clinic',
          start: new Date(2023, 7, 27, 17, 0),
          end: new Date(2023, 7, 27, 18, 0),
        },
        {
          title: 'Rec. Practice Start',
          start: new Date(2023, 7, 28, 16, 30),
          end: new Date(2023, 7, 28, 17, 30),
        },
        {
          title: 'Rec. Practice End',
          start: new Date(2023, 9, 13, 16, 30),
          end: new Date(2023, 9, 13, 17, 30),
        },
        {
          title: 'Illowa Opening Match Day Weekend',
          start: new Date(2023, 7, 26, 10, 30),
          end: new Date(2023, 7, 27, 16, 30),
        },
        {
          title: 'Rec. Game 1',
          start: new Date(2023, 8, 9, 8, 0),
          end: new Date(2023, 8, 9, 12, 0),
        },
        {
          title: 'Rec. Game 2',
          start: new Date(2023, 8, 16, 8, 0),
          end: new Date(2023, 8, 16, 12, 0),
        },
        {
          title: 'Rec. Game 3',
          start: new Date(2023, 8, 23, 8, 0),
          end: new Date(2023, 8, 23, 12, 0),
        },
        {
          title: 'Rec. Game 4',
          start: new Date(2023, 8, 30, 8, 0),
          end: new Date(2023, 8, 30, 12, 0),
        },
        {
          title: 'Rec. Game 5',
          start: new Date(2023, 9, 7, 8, 0),
          end: new Date(2023, 9, 7, 12, 0),
        },
        {
          title: 'Rec. Game 6',
          start: new Date(2023, 9, 14, 8, 0),
          end: new Date(2023, 9, 14, 12, 0),
        },
        {
          title: 'Illowa Closing Match Day Weekend',
          start: new Date(2023, 9, 21, 10, 30),
          end: new Date(2023, 9, 22, 16, 30),
        },
        {
          title: 'Spring Competitive Practice',
          start: new Date(2024, 2, 11, 17, 30),
          end: new Date(2024, 2, 11, 19, 0),
        },
        {
          title: 'End of Spring Competitive Practice',
          start: new Date(2024, 4, 31, 17, 30),
          end: new Date(2024, 4, 31, 19, 0),
        },
        {
          title: 'Illowa League',
          start: new Date(2024, 3, 6, 10, 30),
          end: new Date(2024, 5, 2, 16, 30),
        },
        {
          title: 'Rec. Spring Game 1',
          start: new Date(2024, 3, 6, 8, 0),
          end: new Date(2024, 3, 6, 12, 0),
        },
        {
          title: 'Rec. Spring Game 2',
          start: new Date(2024, 3, 13, 8, 0),
          end: new Date(2024, 3, 13, 12, 0),
        },
        {
          title: 'Rec. Spring Game 3',
          start: new Date(2024, 3, 20, 8, 0),
          end: new Date(2024, 3, 20, 12, 0),
        },
        {
          title: 'Rec. Spring Game 4',
          start: new Date(2024, 3, 27, 8, 0),
          end: new Date(2024, 3, 27, 12, 0),
        },
        {
          title: 'Rec. Spring Game 5',
          start: new Date(2024, 4, 4, 8, 0),
          end: new Date(2024, 4, 4, 12, 0),
        },
        {
          title: 'Rec. Spring Game 6',
          start: new Date(2024, 4, 11, 8, 0),
          end: new Date(2024, 4, 11, 12, 0),
        },
        {
          title: 'OSUSC Competitive Try-Outs',
          start: new Date(2024, 5, 4, 17, 30),
          end: new Date(2024, 5, 6, 19, 0),
        },
      ];
    
    
    
      return (
        <div>
          <h1 className="h2__roboto calendar-title" style={{paddingTop: '2rem', paddingBottom: '2rem'}}>Master Calendar</h1>
          < Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            selectable
            
            style={{ height: 500 }} // Set the height of the calendar
          />
        </div>
      );
    };
export default MasterCalendar